"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContextProvider = exports.GaiaPostHogProvider = exports.POSTHOG_FEATURE_FLAGS = void 0;
exports.usePostHogEvent = usePostHogEvent;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_2 = require("@posthog/react");
var posthog_js_1 = __importDefault(require("posthog-js"));
var config_1 = require("config");
var environment_1 = require("config/environment");
var browser_1 = require("react-universal/browser");
var selectors_1 = require("services/auth/selectors");
var selectors_2 = require("services/user/selectors");
var country_1 = require("services/country");
var environment_2 = require("environment");
var useVideoState_1 = require("./useVideoState");
var queries_generated_1 = require("./queries.generated");
// ============================================================================
// String Constants (so we're not repeating ourselves)
// ============================================================================
exports.POSTHOG_FEATURE_FLAGS = {
    AI_GOTS: 'ai_gots',
    // AI Video Guide Desktop Test - Segment Experiments
    AI_GUIDE_SEGMENT_A: 'ai-video-guide-desktop-a',
    AI_GUIDE_SEGMENT_B: 'ai-video-guide-desktop-b',
    AI_GUIDE_SEGMENT_C: 'ai-video-guide-desktop-c',
    AI_GUIDE_SEGMENT_D: 'ai-video-guide-desktop-d',
};
// ============================================================================
// Module-level Initialization
// ============================================================================
/**
 * Module-level PostHog initialization.
 * Runs when JavaScript is parsed, similar to the Mustache template
 * loading PostHog in the HTML head.
 */
var config = (0, environment_1.isBrowser)() ? (0, config_1.get)() : null;
var isPostHogEnabled = !!((_a = config === null || config === void 0 ? void 0 : config.features) === null || _a === void 0 ? void 0 : _a.posthog);
var posthogApiKey = config === null || config === void 0 ? void 0 : config.posthogApiKey;
// Get bootstrapped feature flags and distinctID from server-side evaluation
var appData = (0, environment_1.isBrowser)() ? (0, browser_1.getAppData)() : null;
var bootstrapData = ((_b = appData === null || appData === void 0 ? void 0 : appData.hydrate) === null || _b === void 0 ? void 0 : _b.posthogBootstrap) || {};
var bootstrappedFlags = bootstrapData.featureFlags || {};
var bootstrappedDistinctID = bootstrapData.distinctID;
var bootstrappedIsIdentifiedID = bootstrapData.isIdentifiedID || false;
// Don't initialize PostHog in test environments to prevent background timers
// from keeping the Node.js event loop alive after tests complete
var isTestEnvironment = process.env.NODE_ENV === 'test' || process.env.BROWSER_TEST;
if ((0, environment_1.isBrowser)() && isPostHogEnabled && posthogApiKey && !isTestEnvironment) {
    posthog_js_1.default.init(posthogApiKey, {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
        capture_pageview: false,
        capture_pageleave: true,
        autocapture: true,
        // Per PostHog docs: "Programmatically start and stop recordings"
        // Set disable_session_recording: true, then call startSessionRecording() manually
        disable_session_recording: true,
        // Bootstrap feature flags and distinctID from server-side evaluation
        // CRITICAL: With person_profiles: 'identified_only', we must include distinctID
        // and isIdentifiedID in bootstrap to prevent events from being dropped
        // This ensures PostHog knows the user is identified from initialization
        bootstrap: __assign(__assign({}, (bootstrappedDistinctID && {
            distinctID: bootstrappedDistinctID,
            isIdentifiedID: bootstrappedIsIdentifiedID,
        })), { featureFlags: bootstrappedFlags }),
        // PostHog automatically detects ?__posthog_debug=true in URL for debug mode
        // No need to set debug in config - it's handled automatically
    });
}
// ============================================================================
// User Identification Component
// ============================================================================
/**
 * Handles automatic user identification based on Redux auth state.
 * Must be rendered inside the official PostHogProvider.
 */
var PostHogUserIdentifier = function (_a) {
    var _b;
    var children = _a.children;
    var posthogClient = (0, react_2.usePostHog)();
    var auth = (0, react_redux_1.useSelector)(selectors_1.selectAuth);
    var uid = auth === null || auth === void 0 ? void 0 : auth.get('uid');
    var username = auth === null || auth === void 0 ? void 0 : auth.get('username');
    var jwt = auth === null || auth === void 0 ? void 0 : auth.get('jwt');
    var country = (0, react_redux_1.useSelector)(selectors_1.selectUserCountry);
    var email = (0, react_redux_1.useSelector)(selectors_2.selectEmail);
    // Fetch authoritative tenure from GraphQL (skipped when not logged in)
    var postHogPropsData = (0, queries_generated_1.useGetCurrentUserPostHogPropertiesQuery)({
        skip: !uid || !jwt,
        context: { jwt: jwt },
    }).data;
    var userInfo = (_b = postHogPropsData === null || postHogPropsData === void 0 ? void 0 : postHogPropsData.userInfoCurrent) === null || _b === void 0 ? void 0 : _b.userInfo;
    var userTenureDays = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userTenureDays;
    var videosLast7Days = userInfo === null || userInfo === void 0 ? void 0 : userInfo.videosLast7Days;
    var daysWithViewershipLast7Days = userInfo === null || userInfo === void 0 ? void 0 : userInfo.daysWithViewershipLast7Days;
    var videoCompletionRate = userInfo === null || userInfo === void 0 ? void 0 : userInfo.videoCompletionRate;
    var medianWatchTimePerWeek = userInfo === null || userInfo === void 0 ? void 0 : userInfo.medianWatchTimePerWeek;
    var engagementCohort = userInfo === null || userInfo === void 0 ? void 0 : userInfo.engagementCohort;
    var aiChatUsageFrequency = userInfo === null || userInfo === void 0 ? void 0 : userInfo.aiChatUsageFrequency;
    var aiGuideInteractionCount = userInfo === null || userInfo === void 0 ? void 0 : userInfo.aiGuideInteractionCount;
    // Conservative defaults: assume GDPR applies, assume not employee
    var isGdprCountry = country ? country_1.GDPR_COUNTRIES.includes(country) : true;
    var isEmployee = email ? email.endsWith('@gaia.com') : false;
    // Detect automated test accounts for filtering in PostHog
    var isTestAccount = username ? username.startsWith('automation-') : false;
    // Device detection (stable for session)
    var deviceType = (0, react_1.useMemo)(function () {
        var device = (0, environment_2.getDeviceType)();
        // Map to PostHog expected values (lowercase)
        if (device === 'Desktop')
            return 'desktop';
        if (device === 'iPhone' || device === 'Android')
            return 'mobile';
        if (device === 'iPad')
            return 'tablet';
        return 'unknown';
    }, []);
    // CRITICAL: Identify user BEFORE starting recording (PostHog best practice)
    // According to PostHog docs: "check that you call identify() before evaluating
    // the feature flag" - this ensures properties are available for filtering
    (0, react_1.useEffect)(function () {
        if (!uid) {
            posthogClient.reset();
            return undefined;
        }
        // Wait for required properties before identifying and starting recording
        // CRITICAL: Country must be available BEFORE starting recording
        // PostHog only associates properties with recordings if they're set at session start
        // Country is required for geo-targeting the enable-session-recording flag
        // Country should be available from auth hydration - if not, this is a bug
        // NOTE: email is optional - some users may not have email addresses
        if (!username || !country || country === '') {
            // eslint-disable-next-line no-console
            console.debug('PostHog: Waiting for required properties', {
                hasUsername: !!username,
                hasEmail: !!email,
                hasCountry: !!country && country !== '',
                country: country,
            });
            return undefined;
        }
        // Call identify() FIRST with all available properties
        // This must complete before startSessionRecording() is called
        // All properties must be set BEFORE recording starts for filtering to work
        // eslint-disable-next-line no-console
        console.log('PostHog: Calling identify()', {
            uid: uid,
            username: username,
            country: country,
            email: email,
        });
        // PostHog requires uid to be a string, not a number
        posthogClient.identify(String(uid), __assign(__assign({ user_id: uid, // Add user_id as property for filtering in PostHog UI
            username: username }, (email && { email: email })), { // Include email if available (optional)
            country: country, is_gdpr_country: isGdprCountry, is_employee: isEmployee, is_test_account: isTestAccount, device_type: deviceType, platform: 'web' }));
        // CRITICAL: Reload feature flags after identify() to ensure they're evaluated
        // with the new person properties. This ensures $active_feature_flags is attached
        // to subsequent events. Without this, bootstrap flags might not be properly
        // evaluated and attached to events.
        posthogClient.reloadFeatureFlags();
        // Programmatically start recording based on feature flag
        // Since we use bootstrap flags, the flag should be available immediately after identify()
        // Per PostHog docs: call startSessionRecording() after identify() and flag check
        // Use setTimeout to ensure identify() completes before checking flag
        setTimeout(function () {
            var _a, _b;
            var shouldRecord = posthogClient.isFeatureEnabled('enable-session-recording');
            // Store feature flag variant values as person properties for filtering
            // PostHog's "Active feature flags" event property shows which flags were active,
            // but doesn't include variant values (e.g., ai_gots = segment-a)
            // Storing as person properties allows filtering by specific variant values
            var featureFlagProperties = {};
            var activeFeatureFlags = [];
            var flagsToCapture = [
                'ai_gots',
                'ai-video-guide-desktop-a',
                'ai-video-guide-desktop-b',
                'ai-video-guide-desktop-c',
                'ai-video-guide-desktop-d',
            ];
            flagsToCapture.forEach(function (flagKey) {
                var flagValue = posthogClient.getFeatureFlag(flagKey);
                if (flagValue !== undefined && flagValue !== null) {
                    // Store the actual variant value (e.g., "segment-a", true, false)
                    // This makes it filterable in PostHog UI: "ai_gots = segment-a"
                    featureFlagProperties[flagKey] = flagValue;
                    // Track which flags are active (for $active_feature_flags event property)
                    // Only include flags that are truthy or have a variant value
                    if (flagValue === true || (typeof flagValue === 'string' && flagValue !== 'false')) {
                        activeFeatureFlags.push(flagKey);
                    }
                }
            });
            // Set feature flag values as person properties if any were found
            if (Object.keys(featureFlagProperties).length > 0) {
                posthogClient.setPersonProperties(featureFlagProperties);
                // eslint-disable-next-line no-console
                console.log('PostHog: Set feature flag variants as person properties', featureFlagProperties);
            }
            // eslint-disable-next-line no-console
            console.log('PostHog: Checking recording flag after identify()', {
                flagEnabled: shouldRecord,
                flagValue: posthogClient.getFeatureFlag('enable-session-recording'),
                recordingStatus: (_a = posthogClient.sessionRecording) === null || _a === void 0 ? void 0 : _a.status,
                featureFlagVariants: featureFlagProperties,
                activeFeatureFlags: activeFeatureFlags,
            });
            if (shouldRecord === true) {
                try {
                    // Start recording manually - this is the programmatic approach
                    posthogClient.startSessionRecording();
                    // CRITICAL: Send an event immediately after starting recording
                    // This ensures $active_feature_flags is attached to the session
                    // Without this event, recordings won't be filterable by "Active feature flags"
                    // PostHog only attaches $active_feature_flags to events, not to recordings directly
                    // Manually include active flags to ensure they're attached even if PostHog's
                    // automatic attachment doesn't work with bootstrap flags
                    posthogClient.capture('session_recording_started', __assign({ recording_initiated: true, 
                        // Manually include $active_feature_flags to ensure filtering works
                        // PostHog should auto-attach this, but we include it explicitly as a fallback
                        $active_feature_flags: activeFeatureFlags }, featureFlagProperties));
                    // Verify recording actually started
                    var recordingStatus = (_b = posthogClient.sessionRecording) === null || _b === void 0 ? void 0 : _b.status;
                    // eslint-disable-next-line no-console
                    console.log('PostHog: Session recording started', {
                        status: recordingStatus,
                        distinctId: posthogClient.get_distinct_id(),
                        activeFeatureFlags: activeFeatureFlags,
                        featureFlagVariants: featureFlagProperties,
                    });
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.error('PostHog: Failed to start session recording', error);
                }
            }
            else {
                // eslint-disable-next-line no-console
                console.log('PostHog: Recording not started (flag disabled)', {
                    country: country,
                    isGdprCountry: isGdprCountry,
                });
            }
        }, 100);
        return undefined;
    }, [
        posthogClient,
        uid,
        username,
        email,
        country,
        isGdprCountry,
        isEmployee,
        isTestAccount,
        deviceType,
    ]);
    // Update person properties when GraphQL data arrives (triggers flag reload)
    // This runs after initial identification and recording start
    (0, react_1.useEffect)(function () {
        if (uid && userTenureDays !== undefined) {
            var updatedValues = __assign(__assign(__assign(__assign(__assign(__assign(__assign({ user_tenure_days: userTenureDays, device_type: deviceType, platform: 'web' }, (videosLast7Days !== undefined && {
                videos_last_7_days: videosLast7Days,
            })), (daysWithViewershipLast7Days !== undefined && {
                days_with_viewership_last_7_days: daysWithViewershipLast7Days,
            })), (videoCompletionRate !== undefined && {
                video_completion_rate: videoCompletionRate,
            })), (medianWatchTimePerWeek !== undefined && {
                median_watch_time_per_week: medianWatchTimePerWeek,
            })), (engagementCohort !== undefined && {
                engagement_cohort: engagementCohort,
            })), (aiChatUsageFrequency !== undefined && {
                ai_chat_usage_frequency: aiChatUsageFrequency,
            })), (aiGuideInteractionCount !== undefined && {
                ai_guide_interaction_count: aiGuideInteractionCount,
            }));
            // Call identify() again with all properties (static + dynamic)
            // This ensures properties appear in PostHog UI Properties tab
            // PostHog requires uid to be a string, not a number
            posthogClient.identify(String(uid), __assign(__assign(__assign({ user_id: uid, // Add user_id as property for filtering in PostHog UI
                username: username }, (email && { email: email })), { country: country, is_gdpr_country: isGdprCountry, is_employee: isEmployee, is_test_account: isTestAccount }), updatedValues));
            // Also set for feature flag evaluation
            posthogClient.setPersonPropertiesForFlags(updatedValues, true);
        }
    }, [
        posthogClient,
        uid,
        username,
        country,
        isGdprCountry,
        isEmployee,
        isTestAccount,
        userTenureDays,
        deviceType,
        videosLast7Days,
        daysWithViewershipLast7Days,
        videoCompletionRate,
        medianWatchTimePerWeek,
        engagementCohort,
        aiChatUsageFrequency,
        aiGuideInteractionCount,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
/**
 * GaiaPostHogProvider wraps the official @posthog/react PostHogProvider.
 * - Passes the pre-initialized posthog client to the official provider
 * - Handles user identification automatically via PostHogUserIdentifier
 *
 * When PostHog is disabled (not initialized), capture calls are no-ops.
 */
var GaiaPostHogProvider = function (_a) {
    var children = _a.children;
    if (!isPostHogEnabled) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return (react_1.default.createElement(react_2.PostHogProvider, { client: posthog_js_1.default },
        react_1.default.createElement(PostHogUserIdentifier, null, children)));
};
exports.GaiaPostHogProvider = GaiaPostHogProvider;
var EventContext = (0, react_1.createContext)(null);
/**
 * Provides event context to child components. All events captured via usePostHogEvent() will
 * automatically include this context.
 *
 * @example
 * <EventContextProvider context="ai_guide_on_the_side">
 *   <VideoGuideChat />
 * </EventContextProvider>
 */
var EventContextProvider = function (_a) {
    var context = _a.context, children = _a.children;
    return (react_1.default.createElement(EventContext.Provider, { value: context }, children));
};
exports.EventContextProvider = EventContextProvider;
/**
 * Helper function to get active feature flags for inclusion in events.
 * PostHog should automatically attach $active_feature_flags, but with bootstrap
 * flags it may not work, so we manually include it to ensure filtering works.
 */
function getActiveFeatureFlags(posthogClient) {
    var flagsToCheck = [
        'ai_gots',
        'ai-video-guide-desktop-a',
        'ai-video-guide-desktop-b',
        'ai-video-guide-desktop-c',
        'ai-video-guide-desktop-d',
    ];
    var activeFlags = [];
    flagsToCheck.forEach(function (flagKey) {
        var flagValue = posthogClient.getFeatureFlag(flagKey);
        // Include flags that are truthy or have a variant value (not false or null)
        if (flagValue === true || (typeof flagValue === 'string' && flagValue !== 'false')) {
            activeFlags.push(flagKey);
        }
    });
    return activeFlags;
}
/**
 * Type-safe hook for tracking PostHog events.
 * Returns a callback with the correct signature for the specified event.
 * Automatically includes context, content_id, feature_media_id, and other
 * common properties.
 *
 * @example
 * const trackMessageSent = usePostHogEvent('ai_message_sent')
 * // Later, at call site:
 * trackMessageSent(message, 'typed', 'keyboard')
 */
function usePostHogEvent(event) {
    var posthogClient = (0, react_2.usePostHog)();
    var eventContext = (0, react_1.useContext)(EventContext);
    var _a = (0, useVideoState_1.useVideoState)(), contentId = _a.contentId, featureMediaId = _a.featureMediaId, getPlaybackState = _a.getPlaybackState;
    // Store latest values in a ref so callbacks can access fresh data without
    // needing to be recreated when dependencies change.
    var contextRef = (0, react_1.useRef)({
        posthogClient: posthogClient,
        eventContext: eventContext,
        contentId: contentId,
        featureMediaId: featureMediaId,
        getPlaybackState: getPlaybackState,
    });
    contextRef.current = {
        posthogClient: posthogClient,
        eventContext: eventContext,
        contentId: contentId,
        featureMediaId: featureMediaId,
        getPlaybackState: getPlaybackState,
    };
    // Create all callbacks once. They read from contextRef for fresh values.
    // This avoids creating N callbacks on every render when only 1 is needed.
    var callbacks = (0, react_1.useMemo)(function () { return ({
        // NOTE: use alphabetic ordering on keys
        ai_conversation_resumed: function () {
            var ctx = contextRef.current;
            var activeFlags = getActiveFeatureFlags(ctx.posthogClient);
            ctx.posthogClient.capture('ai_conversation_resumed', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, 
                // Manually include $active_feature_flags to ensure filtering works
                // PostHog should auto-attach this, but with bootstrap flags it may not
                $active_feature_flags: activeFlags.length > 0 ? activeFlags : undefined }));
        },
        ai_conversation_started: function () {
            var ctx = contextRef.current;
            var activeFlags = getActiveFeatureFlags(ctx.posthogClient);
            ctx.posthogClient.capture('ai_conversation_started', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, 
                // Manually include $active_feature_flags to ensure filtering works
                $active_feature_flags: activeFlags.length > 0 ? activeFlags : undefined }));
        },
        ai_error_response: function (errorCode, errorMessage) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_error_response', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, error_code: errorCode, error_message: errorMessage }));
        },
        ai_message_failure: function (errorMessage) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_message_failure', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, error_message: errorMessage }));
        },
        ai_message_received: function (messagePairId, responseLength) {
            var ctx = contextRef.current;
            var distinctId = ctx.posthogClient.get_distinct_id();
            var activeFlags = getActiveFeatureFlags(ctx.posthogClient);
            // eslint-disable-next-line no-console
            console.log('PostHog: Tracking ai_message_received', {
                messagePairId: messagePairId,
                responseLength: responseLength,
                distinctId: distinctId,
                isIdentified: distinctId && !distinctId.includes('-'), // UUIDs contain dashes, user IDs don't
            });
            ctx.posthogClient.capture('ai_message_received', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, message_pair_id: messagePairId, response_length: responseLength, 
                // Manually include $active_feature_flags to ensure filtering works
                $active_feature_flags: activeFlags.length > 0 ? activeFlags : undefined }));
        },
        ai_message_sent: function (message, source, submissionMethod) {
            var _a;
            var ctx = contextRef.current;
            var playbackState = source === 'typed' ? ctx.getPlaybackState() : null;
            var activeFlags = getActiveFeatureFlags(ctx.posthogClient);
            var distinctId = ctx.posthogClient.get_distinct_id();
            // eslint-disable-next-line no-console
            console.log('PostHog: Tracking ai_message_sent', {
                message: message.substring(0, 50),
                source: source,
                distinctId: distinctId,
                isIdentified: distinctId && !distinctId.includes('-'), // UUIDs contain dashes, user IDs don't
                activeFlags: activeFlags,
                hasClient: !!ctx.posthogClient,
                captureMethod: typeof ((_a = ctx.posthogClient) === null || _a === void 0 ? void 0 : _a.capture),
            });
            ctx.posthogClient.capture('ai_message_sent', __assign(__assign(__assign(__assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, message_length: message.length, source: source }), (submissionMethod && { submission_method: submissionMethod })), ((playbackState === null || playbackState === void 0 ? void 0 : playbackState.currentTimeSeconds) != null && {
                video_time_seconds: playbackState.currentTimeSeconds,
            })), { 
                // CRITICAL: Manually include $active_feature_flags to ensure filtering works
                // PostHog should auto-attach this, but with bootstrap flags it may not
                // This ensures recordings are filterable by "Active feature flags ai_gots"
                $active_feature_flags: activeFlags.length > 0 ? activeFlags : undefined }));
        },
        ai_moderation_violation: function (severity, categories) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_moderation_violation', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, severity: severity, categories: categories }));
        },
        ai_module_closed: function (sessionDurationMs) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_module_closed', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, session_duration_ms: sessionDurationMs }));
        },
        ai_module_opened: function (isInitial) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_module_opened', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, is_initial: isInitial }));
        },
        ai_module_viewed: function () {
            var ctx = contextRef.current;
            var distinctId = ctx.posthogClient.get_distinct_id();
            // eslint-disable-next-line no-console
            console.log('PostHog: Tracking ai_module_viewed', {
                distinctId: distinctId,
                isIdentified: distinctId && !distinctId.includes('-'), // UUIDs contain dashes, user IDs don't
            });
            ctx.posthogClient.capture('ai_module_viewed', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId }));
        },
        ai_response_feedback: function (value) {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_response_feedback', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId, value: value }));
        },
        ai_videoguide_disabled: function () {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_videoguide_disabled');
        },
        ai_videoguide_enabled: function () {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('ai_videoguide_enabled');
        },
        video_started: function () {
            var ctx = contextRef.current;
            ctx.posthogClient.capture('video_started', __assign(__assign({}, (ctx.eventContext && { context: ctx.eventContext })), { content_id: ctx.contentId, feature_media_id: ctx.featureMediaId }));
        },
    }); }, []);
    return callbacks[event];
}
